/** Documentation page: https://docs.fiserv.dev/public/docs/response-fields */
/** Same object Dto is being posted to the /payment-aib/notification webhook endpoint */
export class AibLandingDto {

  /** Time of transaction processing */
  txndate_processed: string

  /** 6 digit identifier of the card issuing bank   */
  ccbin: string;

  /** Client timezone (from request) */
  timezone: string;

  /** TODO match payment in our system using this */
  /** Order ID, if not defined in the request, the Gateway generates it automatically */
  oid: string;

  /** 3 letter alphanumeric ISO code of the cardholder’s country */
  cccountry: string;

  /** card expiration month */
  expmonth: string;

  /** Algorithm used for obtaining the hash (response_hash) */
  hash_algorithm: string;

  /** todo find what it is ? */
  endpointTransactionId: string;

  /** Represents the numeric ISO code of the transaction currency, e.g. 978 for EUR. */
  currency: string;

  /** The response code provided by the backend system.
   *
   *  Note that response codes can be different depending on the used payment type and backend system.
   *  While for credit card payments, the response code 00 is the most common response for an approval,
   *  the backend for giropay transactions for example returns the response code 4000 for successful transactions.
   */
  processor_response_code: string;

  /** This is the total amount of the transaction using a dot or comma as decimal separator,
   * e. g. 12.34 for an amount of 12 Euro and 34 Cent. Group separators like 1,000.01 / 1.000,01 are not allowed.
   */
  chargetotal: string;

  /** Terminal ID used for transaction processing  */
  terminal_id: string;

  /**
   * Approval code for the transaction. The first character of this parameter is the most helpful indicator for
   * verification of the transaction result.
   *
   * Y indicates that the transaction has been successful, N indicates that the transaction has not been successful,
   * ? indicates that the transaction has been successfully initialized, but a final result is not yet available since
   * the transaction is now in a waiting status. The transaction status will be updated at a later stage.
   */
  approval_code: string;

  /** Credit card expiration year */
  expyear: string;

  /**
   * 3-D Secure transactions
   * 1 - Successful authentication (VISA ECI 05, MasterCard ECI 02)
   * 2 - Successful authentication without AVV (VISA ECI 05, MasterCard ECI 02)
   * 3 - Authentication failed / rejected by the DS or ACS (transaction declined by the Gateway)
   * 4 - Authentication attempt (VISA ECI 06, MasterCard ECI 01)
   * 5 - Unable to authenticate / DS not responding (VISA ECI 07)
   * 6 - Unable to authenticate / ACS or DS are unable to authenticate the cardholder (VISA ECI 07)
   * 7 - Cardholder not enrolled for 3-D Secure (VISA ECI 07) - relevant for 3DS 1.0
   * 8 - Invalid 3-D Secure values received
   * 9 - Tokenisation (tokenised PAN, eWallet)
   */
  response_code_3dsecure: string;

  /** API endpoint webhook for notifying the transaction response */
  transactionNotificationURL: string;

  /**
   * Credential-on-file transactions
   * Returned in the response by a scheme for stored credentials transactions to be used in subsequent transaction requests as a reference
   */
  schemeTransactionId: string;

  /** Identification for the specific transaction */
  tdate: string;

  /** TODO undocumented */
  installments_interest: string;

  /** Customer's name. Alphanumeric characters, spaces and dashes limited to 96. */
  bname: string;

  /** Brand of the credit or debit card   */
  ccbrand: string;

  /** Reference number */
  refnumber: string;

  /** (from request) The field represents a transaction type. Available values:
   * 'sale’, 'preauth’, 'postauth’, or ‘payer_auth’
   */
  txntype: string;

  /** Payment method */
  paymentMethod: string;

  /** (from request) Exact transaction date and time; in the format "YYYY:MM:DD-hh:mm:ss" */
  txndatetime: string;

  /** Card number: '(type) ... last_4_digits' */
  cardnumber: string;


  /** Transaction identifier assigned by the Gateway, e.g. to be used for a Void   */
  /** TODO this needs to be saved for VOID */
  ipgTransactionId: string;

  /** Transaction status
   *
   * APPROVED, DECLINED (by authorisation endpoint or due to fraud prevention settings),
   * FAILED (wrong transaction message content/parameters, etc.)
   * or WAITING (asynchronous Alternative Payment Methods)
   */
  status: string;

  // region ##Failed transaction - specific fields

  /** Reason the transaction failed */
  fail_reason: string;

  /** Reason the transaction failed */
  fail_rc: string;

  // endregion

  // Custom Fields documentation: https://docs.fiserv.dev/public/docs/custom-fields
  // region ### Custom fields


  customParam_source: string; // tracks which is the application that initiated the transaction

  // endregion ### Custom fields

  // region ### Transaction Security - specific fields

  /** https://docs.fiserv.dev/public/docs/response-fields#hash-validation
   *
   * Hash obtained from values of:
   * approval_code|chargetotal|currency|txndatetime|storename
   *
   * Field present when the transaction response is passed to the landing route directly from the payment gateway.
   */
  response_hash?: string;

  /** Hash-Value to protect the communication, where all response parameters are included in the hash calculation see note below. */
  /** I asked AIB support team to enable this feature at gateway level so we can be 100% sure that a payment response is not being interfered with */
  extended_response_hash: string;

  /** Hash-Value to protect the communication, where all request parameters are included in the hash calculation see note below.
   * Field present when the response is passed to the notification route (webhook) as Server-to-Server from payment gateway.
   * */
  notification_hash?: string;

  // endregion
}


/** sample success
 {
   txndate_processed: '10/07/25 11:34:06',
   ccbin: '414746',
   timezone: 'Europe/Bucharest',
   oid: 'C-614c4af8-dfba-4dc3-9df5-36ae87b6ac7f',
   cccountry: 'SGP',
   expmonth: '03',
   hash_algorithm: 'HMACSHA256',
   endpointTransactionId: '8618',
   currency: '978',
   processor_response_code: '00',
   chargetotal: '120.55',
   terminal_id: '99770023',
   approval_code: 'Y:934479:4622159470:PPXM:8618',
   expyear: '2030',
   response_hash: 'u6HWMkjK6k+GjppQBreSvuVSiz86s1MgCscS3cKEAkc=',
   response_code_3dsecure: '1',
   transactionNotificationURL: 'https://ladybug-eternal-quietly.ngrok-free.app/api/payment-aib/notification',
   schemeTransactionId: '500000000934486',
   tdate: '1752140046',
   installments_interest: 'false',
   bname: 'test user 23',
   ccbrand: 'VISA',
   refnumber: '934479',
   txntype: 'sale',
   paymentMethod: 'V',
   txndatetime: '2025:07:10-12:33:24',
   cardnumber: '(VISA) ... 0083',
   ipgTransactionId: '84622159470',
   status: 'APPROVED'
 }

 */

/** sample failure
 {
   cardholderInfo: 'Transaction has High risk`',
   txndate_processed: '10/07/25 12:32:07',
   ccbin: '414746',
   timezone: 'Europe/Bucharest',
   fail_rc: '50716',
   oid: 'C-89404f8a-8479-44e5-ae3d-8865b5d6796f',
   cccountry: 'SGP',
   expmonth: '05',
   hash_algorithm: 'HMACSHA256',
   currency: '978',
   chargetotal: '150.55',
   approval_code: 'N:-50716:3D Secure authentication failed',
   expyear: '2030',
   response_hash: 'Q364H/xEx4iC1CKl5vR+LMieWYawiINZp94uqngNWFQ=',
   response_code_3dsecure: '3',
   transactionNotificationURL: 'https://ladybug-eternal-quietly.ngrok-free.app/api/payment-aib/notification',
   tdate: '1752143527',
   installments_interest: 'false',
   bname: 'test user 23',
   ccbrand: 'VISA',
   txntype: 'sale',
   paymentMethod: 'V',
   txndatetime: '2025:07:10-13:31:09',
   cardnumber: '(VISA) ... 0091',
   ipgTransactionId: '84622162970',
   fail_reason: 'Transaction declined. 3D Secure authentication failed.',
   status: 'FAILED'
 }
 */